export default __webpack_public_path__ + "static/media/titulo.868c5e1c.png";